module.exports = __webpack_public_path__ + "img/service_wechat_4.1cb574ce.png";